module.exports = "<ul class=\"error-messages\" *ngIf=\"errorList\">\r\n  <li *ngFor=\"let error of errorList\">\r\n    {{ error }}\r\n  </li>\r\n</ul>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list-errors.component.html
// module id = 798
// module chunks = 1